import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#FFFFFF"
}
function SkiMak029({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M50.9 23.6q0-1.75-2.9-3.2 0-.05-7.7-3.15-3.2-1.3-3.45-3.6-.3-2.3-1.15-2.95-.85-.65-5.55-.5-4.7.15-6.55-1.35-1.1-.85-3.2-4.4Q19 1.9 11 .6 3-.7.9 1.65-1.2 4 1.55 11.2q2.75 7.15 4.05 8.45 1.25 1.25 2.8 3.45 1 1.45 2.05 2.2.9.7 2.45 1.25 3.25 1.2 6.1 6.05 2.3 3.8 7.65 3.8 4.6 0 6.95-1.85 2.5-2.9 4.7-5 1.15-1 7.35-2.8 5.25-1.4 5.25-3.15M93.1 8.85Q91 6.3 87 3.5 82 0 75 5.2q-6.95 5.2-7.9 6.85-.85 1.55-.7 2.9.3 2.25 2.15 2.65 2.5.5 3.3 1.5.9 1.05 2.35 1.75 1.15.9 1.65 1.15 1.55.8 4.3.95h3.75q1.75-.55 4-2.3 2.3-1.85 3.35-2.25 2.85-1.1 3.8-2.05.85-.85.85-2.25 0-2.9-2.8-5.25m63 4.95q3.3-3.55 4.05-5.75t.1-4.25q-2.65-5.75-8.45-2.75Q146 4 144.35 5.2q-1.7 1.15-2.3 1.4-2.7.95-3.85 2.75-3.05 4.7-5.45 5.1-5.55.35-7.75.55-3.75.35-3.75 2.3 0 .9.85 1.7.8.85.8 1.85 0 1.65-4.1 4.05t-4.1 3.85q0 1.55 2.15 2.4 1.2.4 3.35 1 1.2.5 2.35 1.1 7.4 5.05 17.15 0 1.15-.5 2.4-1.15 7.75-3.9 8.9-7.15.7-3.3 1.1-4.85.65-2.8 4-6.3z"
                    id="SkiMak029__Symbol_36_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#SkiMak029__Symbol_36_0_Layer0_0_FILL"
                transform="translate(112.45 184.2)"
                id="SkiMak029__col1n"
            />
        </g></g>
    )
}
export default SkiMak029
